import { selfAxios } from "@oppein/op-utils";
/**
 * 生成id的接口(业务用于生成拆板规则或者特例规则页面ID,用于写页面)
 */
export async function postGenerateMajorId() {
  const { data } = await selfAxios.post(
    "/quotation/designQuotationResultController/generateMajorId",
  );
  return data.data;
}



// WEBPACK FOOTER //
// ./src/api/quotaion/designQuotationResultController/generateMajorId/post.js